<template>
  <section id="industries" class="flex-section d-flex flex-column center">
    <div class="section-wrapper d-flex flex-column">
      <p class="header-2 bold">Industries</p>
      <div class="section-body mg-150" v-if="!isMobile">
        <div class="section-content relative">
          <div class="float-top symbol-01" />
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="flex-section d-flex flex-column ma-4 pa-8 relative"
              outlined
              :elevation="hover ? 5 : 0"
            >
              <div class="title-industry centered-box kor">공공 (Public)</div>
              <div class="text-2 mg-50">스마트시티 (Smart City)</div>
              <div class="text-2 color-grey">
                헬스데이터, 스마트 그리드,
                <br />스트리밍 데이터 마이닝, 공간정보, 기상정보
              </div>
              <div class="space-25" />
              <div class="text-2">빅데이터 기반 행정 (Administration)</div>
              <div class="text-2 color-grey">
                시민의식, 여론조사, 오픈데이터
              </div>
              <div class="mg-150" />
              <div class="bottom-button">
                <v-btn
                  color="#2799FA"
                  dark
                  @click="onClickRelatedInsight('공공 (Public)')"
                  >Related Insights</v-btn
                >
              </div>
            </v-card>
          </v-hover>
        </div>
        <div class="section-content relative">
          <div class="float-top symbol-02" />
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="flex-section d-flex flex-column ma-4 pa-8"
              outlined
              :elevation="hover ? 5 : 0"
            >
              <div class="title-industry centered-box kor">연구 (R&D)</div>
              <div class="text-2 mg-50">의료 (Medical)</div>
              <div class="text-2 color-grey">
                질병/감염병 전파, 보건의료정보
              </div>
              <div class="space-25" />
              <div class="text-2">식품/안전 (Food Safety)</div>
              <div class="text-2 color-grey">위해도 평가, 재난 안전</div>
              <div class="space-25" />
              <div class="text-2">교육 (Education)</div>
              <div class="text-2 color-grey">교육정책, 여론평가</div>

              <div class="bottom-button">
                <v-btn
                  color="#2799FA"
                  dark
                  @click="onClickRelatedInsight('연구 (R&D)')"
                  >Related Insights</v-btn
                >
              </div>
            </v-card>
          </v-hover>
        </div>
        <div class="section-content relative">
          <div class="float-top symbol-03" />
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="flex-section d-flex flex-column ma-4 pa-8"
              outlined
              :elevation="hover ? 5 : 0"
            >
              <div class="title-industry centered-box kor">B2B</div>
              <div class="text-2 mg-50">마케팅/CRM</div>
              <div class="text-2 color-grey">
                마케팅 효과분석, 제품기획, 딥애널리틱스,
                <br />소비자 조사
              </div>
              <div class="space-25" />
              <div class="text-2">제조/물류/유통</div>
              <div class="text-2 color-grey">
                스마트 팩토리, 수요예측, 데이터 시스템 구축,
                <br />ML-based Revenue
              </div>
              <div class="mg-150" />
              <div class="bottom-button">
                <v-btn
                  color="#2799FA"
                  dark
                  @click="onClickRelatedInsight('B2B')"
                  >Related Insights</v-btn
                >
              </div>
            </v-card>
          </v-hover>
        </div>
      </div>
      <div class="section-body d-flex flex-column mg-50" v-else>
        <v-carousel
          v-model="mobileCurrent"
          class="flex-container"
          hide-delimiters
          :show-arrows="false"
        >
          <v-carousel-item class="flex-container section-body">
            <div class="section-content relative">
              <div class="float-top symbol-01" />
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="flex-section mobile-card d-flex flex-column pa-8"
                  outlined
                  light
                  :elevation="hover ? 5 : 0"
                >
                  <div class="title-mobile centered-box">공공 (Public)</div>
                  <div class="text-2 mg-25">스마트시티 (Smart City)</div>
                  <div class="text-2 color-grey">
                    헬스데이터, 스마트 그리드,
                    <br />스트리밍 데이터 마이닝, 공간정보, 기상정보
                  </div>
                  <div class="space-25" />
                  <div class="text-2">빅데이터 기반 행정 (Administration)</div>
                  <div class="text-2 color-grey">
                    시민의식, 여론조사, 오픈데이터
                  </div>
                  <div class="bottom-button">
                    <v-btn
                      color="#2799FA"
                      dark
                      @click="onClickRelatedInsight('공공 (Public)')"
                      >Related Insights</v-btn
                    >
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-carousel-item>
          <v-carousel-item class="flex-container section-body">
            <div class="section-content relative">
              <div class="float-top symbol-02" />
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="flex-section mobile-card d-flex flex-column pa-8"
                  outlined
                  light
                  width="100%"
                  :elevation="hover ? 5 : 0"
                >
                  <div class="title-mobile centered-box">연구 (R&D)</div>
                  <div class="text-2 mg-25">의료 (Medical)</div>
                  <div class="text-2 color-grey">
                    질병/감염병 전파, 보건의료정보
                  </div>
                  <div class="space-25" />
                  <div class="text-2">식품/안전 (Food Safety)</div>
                  <div class="text-2 color-grey">위해도 평가, 재난 안전</div>
                  <div class="space-25" />
                  <div class="text-2">교육 (Education)</div>
                  <div class="text-2 color-grey">교육정책, 여론평가</div>

                  <div class="bottom-button">
                    <v-btn
                      color="#2799FA"
                      dark
                      @click="onClickRelatedInsight('연구 (R&D)')"
                      >Related Insights</v-btn
                    >
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-carousel-item>
          <v-carousel-item class="flex-container section-body">
            <div class="section-content relative">
              <div class="float-top symbol-03" />
              <v-hover v-slot:default="{ hover }">
                <v-card
                  class="flex-section mobile-card d-flex flex-column pa-8"
                  outlined
                  light
                  :elevation="hover ? 5 : 0"
                >
                  <div class="moblie-title centered-box kor">B2B</div>
                  <div class="text-2 mg-25">마케팅/CRM</div>
                  <div class="text-2 color-grey keep-all">
                    마케팅 효과분석, 제품기획, 딥애널리틱스, 소비자 조사
                  </div>
                  <div class="space-25" />
                  <div class="text-2">제조/물류/유통</div>
                  <div class="text-2 color-grey keep-all">
                    스마트 팩토리, 수요예측, 데이터 시스템 구축, ML-based
                    Revenue
                  </div>

                  <div class="bottom-button">
                    <v-btn
                      color="#2799FA"
                      dark
                      @click="onClickRelatedInsight('B2B')"
                      >Related Insights</v-btn
                    >
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-carousel-item>
        </v-carousel>
        <div class="mg-25" />
        <div class="flex-container ai-center">
          <div class="text-2">{{ `0${mobileCurrent + 1}` }}</div>
          <div class="text-2 color-grey ma-1">/</div>
          <div class="text-2 color-grey">{{ `03` }}</div>
          <v-progress-linear
            class="progress-bar"
            :value="sliderValue"
            color="#1c1c1c"
            height="2px"
          ></v-progress-linear>
          <template>
            <div v-if="mobileCurrent > 0" class="btn-prev" @click="prev" />
            <div v-else class="btn-prev disabled" />
          </template>
          <template>
            <div v-if="mobileCurrent < 2" class="btn-next" @click="next" />
            <div v-else class="btn-next disabled" />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: () => ({
    mobileCurrent: 0,
  }),
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
    sliderValue() {
      return ((this.mobileCurrent + 1) * 100) / 3;
    },
  },
  methods: {
    onClickRelatedInsight(category) {
      if (this.isMobile) {
        this.$router.push("/insights");
      } else {
        this.$store.state.showInsightModal = true;
        this.$store.state.selectedInsightCategory = category;
      }
    },
    next() {
      this.mobileCurrent++;
    },
    prev() {
      this.mobileCurrent--;
    },
  },
};
</script>

<style>
.v-window__container {
  width: 100%;
}

.title-industry {
  font-size: 20px;
}

.mg-100 {
  margin-top: 100px;
}

.mg-50 {
  margin-top: 50px;
}

.mg-25 {
  margin-top: 25px;
}

.centered-box {
  width: 100%;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.float-top {
  width: 100%;
  height: 200px;
  top: -24%;
  position: absolute;
  z-index: 3;
}

.bottom-button {
  position: absolute;
  left: 50%;
  bottom: 50px;
  transform: translate(-50%, -50%);
}

.symbol-01 {
  background: url("../assets/symbol_01.png");
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.symbol-02 {
  background: url("../assets/symbol_02.png");
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.symbol-03 {
  background: url("../assets/symbol_03.png");
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

@media only screen and (max-width: 880px) {
  [class*="float-top"] {
    height: 150px;
    top: 17px;
  }

  .mobile-card {
    width: 100%;
    margin-top: 120px;
    height: 380px;
  }

  .title-mobile {
    font-size: 14px;
  }

  .bottom-button {
    bottom: 10px;
  }

  .progress-bar {
    margin-left: 15px;
    width: 220px;
  }
}
</style>
